import { TRENDEX_COOKIES } from 'config/_const';
import { IToken } from 'interfaces/token.interface';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';

export const setJwtToken = (JWTToken: string) => {
  Cookies.set(TRENDEX_COOKIES.JWT_TDX.name, JWTToken, {
    expires: TRENDEX_COOKIES.JWT_TDX.expiresAsDays,
  });
};

export const getJwtToken: () => string | undefined = () => {
  return Cookies.get(TRENDEX_COOKIES.JWT_TDX.name);
};

export function getDecodedToken(token: string): IToken | null {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
}

export const isJwtTokenValid: () => boolean = () => {
  const JWTToken = getJwtToken();
  if (!JWTToken) return false;

  const decodedJWT = getDecodedToken(JWTToken);
  if (decodedJWT) {
    return decodedJWT.exp * 1000 > Date.now();
  }

  return false;
}

